// extracted by mini-css-extract-plugin
module.exports = {"title":"e_3y","icon":"e_4y"};